import {collection, getDocs} from 'firebase/firestore';
import {db} from '../firebase';

import { Marathon } from "../globalValues";

export default async function getMarathonWallpapers() {
    try {
        const tempList: Marathon[] = [];

        const destinyLore = await getDocs(collection(db, "Marathon-Wallpapers"));

        destinyLore.forEach(doc => {
            const temp = {
                id: doc.id,
                url: doc.data().url,
                season: doc.data().season,
                thumbnail: doc.data().thumbnail
            }
            tempList.push(temp);
        });
        tempList.sort(function(a, b) { 
            var textA = parseInt(a.season);
            var textB = parseInt(b.season);
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        
        const d = new Date();
        sessionStorage.setItem("listofWallpapers-Marathon", JSON.stringify(tempList));
        localStorage.setItem("Last-Fetch-Time-Marathon", JSON.stringify(d.getTime()));

        
        return tempList;
    }
    catch(e) {
        console.log(e);
    }    
}

